var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiploma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0854 56.75C12.0854 44.375 12.0854 18.5 12.0854 14C12.0854 8.375 14.3637 5 21.1987 5C28.0336 5 49.6777 5 57.6518 5C65.6259 5 66.765 11.75 65.6259 14C61.9806 14 58.2594 14 57.5 14C57.5 13.25 57.1743 11.339 57.5 10.5C58.1479 8.8307 59.5504 8.75 59.9301 8.375C58.7909 8.375 56.5126 9.05 56.5126 11.75C56.5126 15.125 56.5126 57.875 56.5126 61.25C56.5126 64.625 55.3734 68 48.5385 68C41.7035 68 14.3637 68 8.66794 68C4.11131 68 3.73159 62.75 4.11131 60.125H46.2601C46.6398 62.4529 48.0828 67.0621 50.8167 66.875C56.0788 66.5149 52.3062 47.75 49 41C50.1392 40.25 50.8167 38.075 50.8167 35.375C50.8167 30.875 47.8548 27.5 43.5 27.5C38.9434 27.5 35.8964 31.5 35.8964 35.375C35.8964 39.875 38.1748 41.375 39.3139 42.125L37.0356 54.5L43.8705 52.25L50 54.5",
    stroke: "url(#paint0_linear_11408_354207)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11408_354207",
    x1: 4,
    y1: 4.27286,
    x2: 76.4107,
    y2: 51.4955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D9941"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.da3773dc3ea598e66269650a1e84a833.svg";
export { ForwardRef as ReactComponent };